/* eslint-disable react-hooks/exhaustive-deps */
//Standard libraries
import React, { useMemo, useEffect, useState, useCallback, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
//Redux
import {
  orderItemsSelector,
  // cartModalOpenSelector,
  cartModalOpenItemAddedSelector,
  itemsAddedInCartOneTimeSelector,
} from "../../../redux/selectors/order";
import * as orderActions from "../../../redux/actions/order";
//UI
import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
import {
  StyledBox,
  StyledButton,
  StyledIconButton,
  StyledLink,
  StyledModal,
  StyledTypography,
} from "../../../styled-mui";
import * as ROUTES from "../../../constants/routes";
import { SvgClose } from "../../svg/close";
import { SvgCheckThick } from "../../svg/checkThick";
import Hidden from "@mui/material/Hidden";
import { SvgChevronBack } from "../../svg/chevronBack";
import { StyledOrderItem } from "../../elements/order-item/styled-orderItem";
import { ImageLayout } from "../../elements/image";
import { ProductAvis } from "../../elements/product-avis/ProductAvis";
import storeUtil from "../../../utils/storeUtil";
import ProductRecommended from "../../elements/product-recommanded/ProductRecommended";
import ProductIndispensable from "../../elements/product-indispensable/ProductIndispensable";
import {
  FIND_PRODUCT_DETAIL_BY_ID_CART,
  PRODUCT_DETAIL_BY_ID,
  PRODUCT_SUMMARY_PROFILE,
  WIDGET_CROWNPEAK,
} from "../../../constants/common";
import { PriceDisplay } from "../formatted-price-display/formatted-price-display";
import { currentContractIdSelector } from "../../../redux/selectors/contract";
import productsService from "../../../_foundation/apis/search/products.service";
import { useSite } from "../../../_foundation/hooks/useSite";
import Axios, { Canceler } from "axios";
import { localStorageUtil } from "../../../_foundation/utils/storageUtil";
import { site } from "../../../_foundation/constants/site";
import { RootReducerState } from "../../../redux/reducers";

/**
 * useFetchCpProduct component to fetch wp posts
 *
 * @param {number} widgetId Number of posts to fetch (default 3)
 * @param {string | null} [category] Wordpress category to fetch
 */

const CartConfirmModal: React.FC = () => {
  const orderItems = useSelector(orderItemsSelector);
  // const modalOpen = useSelector(cartModalOpenSelector);
  const itemsAdded = useSelector(cartModalOpenItemAddedSelector); // This is actually cartItemAdded (array of last added items)
  const qty = useSelector(itemsAddedInCartOneTimeSelector);
  const contract = useSelector(currentContractIdSelector);
  const dispatch = useDispatch();
  const [FpcProductIds, setfpcProductIds] = useState([]);
  const location = useLocation();
  const [isCartData, setIsCartData] = useState<any | null>(null);
  // const [loading, setLoading] = useState<boolean>(true);
  // const [error, setError] = useState<boolean>(false);
  const [isFetched, setIsFetched] = useState<boolean>(false);
  const [indispensableProducts, setIndispensableProducts] = useState<any[]>([]);
  const [selectedIndispensables, setSelectedIndispensables] = useState<any[]>([]);
  // indispensables should be an array of product objects (with partNumber, merchandisingAssociations, etc.)
  const indispensables = useSelector((state: RootReducerState) => state.indispensablesReducer).orderItem;
  const [enrichedMiniCartItems, setEnrichedMiniCartItems] = useState<any[]>([]);
  const cartUpdatingRef = useRef(false);
  const cartHandledRef = useRef(false);

  const { mySite } = useSite();
  const CancelToken = Axios.CancelToken;
  const cancels: Canceler[] = [];
  const storeId: string = mySite ? mySite.storeID : "";
  const widgetName = WIDGET_CROWNPEAK.ADD_TO_CART;
  // Show only recently added items (including indispensables just added)
  // Accumulate all items added during the modal session
  const [sessionAddedItems, setSessionAddedItems] = useState<any[]>([]);
  const areSameProducts = (a: any[], b: any[]) => {
    if (a.length !== b.length) return false;
    return a.every((item, i) => item.partNumber === b[i]?.partNumber);
  };
  // Reset sessionAddedItems when modal is closed or opened for a new product
  useEffect(() => {
    if (!isFetched) {
      setSessionAddedItems([]);
    }
  }, [isFetched, location.pathname]);

  // Add new items to sessionAddedItems when itemsAdded changes, tracking recently added quantity for each
  useEffect(() => {
    if (itemsAdded && itemsAdded.length > 0) {
      setSessionAddedItems((prev) => {
        // Merge by orderItemId or partNumber, avoid duplicates, and track localQuantity for each session add
        const map = new Map();
        // Add previous session items
        prev.forEach((item) => {
          const key = item.orderItemId || item.partNumber;
          if (key) map.set(key, item);
        });
        // Add/overwrite with new items, attaching localQuantity = item.quantity (or fallback to qty)
        itemsAdded.forEach((item) => {
          const key = item.orderItemId || item.partNumber;
          // Tag as indispensable if it matches an indispensable partNumber
          const isIndispensable = indispensables && indispensables.some((ind) => ind.partNumber === item.partNumber);
          const localQuantity = item.quantity !== undefined ? item.quantity : qty;
          if (key) map.set(key, { ...item, localQuantity, isIndispensable });
        });
        return Array.from(map.values());
      });
    }
  }, [itemsAdded, qty]);

  // Show all items added in this session, always use enriched orderItems for display
  // const miniCartItems = useMemo(() => {
  //   if (!sessionAddedItems || sessionAddedItems.length === 0) return [];
  //   return sessionAddedItems.map((added) => {
  //     const enriched = orderItems.find(
  //       (o) =>
  //         (added.orderItemId && o.orderItemId === added.orderItemId) ||
  //         (added.partNumber && o.partNumber === added.partNumber)
  //     );
  //     // If this item was tagged as indispensable, always set localQuantity = 1 for price display
  //     if (added.isIndispensable) {
  //       return enriched ? { ...enriched, localQuantity: 1 } : { ...added, localQuantity: 1 };
  //     }
  //     // Otherwise, use the localQuantity from sessionAddedItems
  //     return enriched ? { ...enriched, localQuantity: added.localQuantity } : added;
  //   });
  // }, [sessionAddedItems, orderItems]);
  const miniCartItems = useMemo(() => {
    if (!sessionAddedItems?.length) return [];

    return sessionAddedItems.map((added) => {
      const fromStore = orderItems.find(
        (o) =>
          (added.orderItemId && o.orderItemId === added.orderItemId) ||
          (added.partNumber && o.partNumber === added.partNumber)
      );

      //  ALWAYS render something
      const base = fromStore || added;

      return {
        ...base,
        localQuantity: added.isIndispensable ? 1 : added.localQuantity ?? 1,
        // Ensure minimum fields exist for rendering
        name: base.name || added.name,
        partNumber: base.partNumber || added.partNumber,
        thumbnailRaw: base.thumbnailRaw || added.thumbnailRaw,
      };
    });
  }, [sessionAddedItems, orderItems]);

  const widgetId = WIDGET_CROWNPEAK.ADD_TO_CART;
  const variables =
    FpcProductIds.length > 0 ? `{ "$productId": ${FpcProductIds.map((item) => `"${item}"`).join(",")} }` : null;
  const handleCloseModal = () => {
    setIsCartData(null);
    setIsFetched(false);
    dispatch(orderActions.CLOSE_CONFIRM_MODAL_ACTION({}));
    setfpcProductIds([]);
    setSessionAddedItems([]);
  };

  useEffect(() => {
    // Call the function whenever the URL changes
    setIsCartData(null);
    setIsFetched(false);
    handleCloseModal();
  }, [location.pathname]);

  useEffect(() => {
    // Always try to fetch recommendations based on the last main product added
    let productIds: any[] = [];
    if (miniCartItems && miniCartItems.length > 0) {
      productIds = miniCartItems.map((item) => item.productId).filter((id) => id !== undefined && id !== null);
    }
    // If miniCartItems is empty, try to use the last main product from sessionAddedItems
    if ((!productIds || productIds.length === 0) && sessionAddedItems && sessionAddedItems.length > 0) {
      // Find the last non-indispensable product
      const lastMainProduct = [...sessionAddedItems].reverse().find((item) => !item.isIndispensable && item.productId);
      if (lastMainProduct && lastMainProduct.productId) {
        productIds = [lastMainProduct.productId];
      }
    }
    if (!productIds || productIds.length === 0) return;
    const parameters: any = {
      id: productIds,
      contractId: contract,
      profileName: FIND_PRODUCT_DETAIL_BY_ID_CART,
      excludedAttribute:
        mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE &&
        mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE.length > 0 &&
        mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE,
    };
    // productsService
    //   .findProductsUsingGET(parameters)
    //   .then((res) => {
    //     if (res.data.contents && res.data.contents.length > 0) {
    //       // Only use defined parentCatalogEntryID
    //       const parentProductIds: any = res.data.contents
    //         .map((content) => content.parentCatalogEntryID)
    //         .filter((id) => id !== undefined && id !== null);
    //       if (parentProductIds.length === 0) return;
    //       const params: any = {
    //         id: parentProductIds,
    //         contractId: contract,
    //         profileName: FIND_PRODUCT_DETAIL_BY_ID_CART,
    //         excludedAttribute:
    //           mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE &&
    //           mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE.length > 0 &&
    //           mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE,
    //       };
    //       productsService
    //         .findProductsUsingGET(params)
    //         .then((productData: any) => {
    //           if (productData.data.contents && productData.data.contents.length > 0) {
    //             const fpcProducts: any = productData.data.contents
    //               .map((product) => product.partNumber)
    //               .filter((id) => id !== undefined && id !== null);
    //             setfpcProductIds(fpcProducts);
    //           }
    //         })
    //         .catch((e) => {
    //           console.log("Could not retrieve product details page informarion", e);
    //         });
    //     }
    //   })
    //   .catch((e) => {
    //     console.log("could not retreive the parent product details", e);
    //   });
    productsService
      .findProductsUsingGET(parameters)
      .then((res) => {
        const contents = res?.data?.contents;
        if (!contents || contents.length === 0) return;

        const productMap = new Map(contents.map((content: any) => [content.partNumber, content]));

        const parentProductIds: any = res.data.contents
          .map((content) => content.parentCatalogEntryID)
          .filter((id) => id !== undefined && id !== null);
        if (parentProductIds.length === 0) return;

        contents.forEach((content: any) => {
          parentProductIds.push(content.parentCatalogEntryID);
        });

        const enrichedItems = miniCartItems.map((item) => {
          const productDetails = productMap.get(item.partNumber) || null;

          return {
            ...item,
            productDetails: productDetails
              ? {
                  ...productDetails,
                  localQuantity: qty,
                  xitem_COEFF_CONVERSION: item?.xitem_COEFF_CONVERSION,
                }
              : null,
          };
        });

        setEnrichedMiniCartItems(enrichedItems);
        // const params = {
        //   id: parentProductIds,
        //   contractId: contract,
        //   profileName: FIND_PRODUCT_DETAIL_BY_ID_CART,
        //   excludedAttribute:
        //     mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE?.length > 0
        //       ? mySite.storeCfg.userData.PDP_FILTER_ATTRIBUTE
        //       : undefined,
        // };

        const params: any = {
          id: parentProductIds,
          contractId: contract,
          profileName: FIND_PRODUCT_DETAIL_BY_ID_CART,
          excludedAttribute:
            mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE &&
            mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE.length > 0 &&
            mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE,
        };

        return productsService.findProductsUsingGET(params);
      })
      .then((productData: any) => {
        const contents = productData?.data?.contents;
        if (!contents || contents.length === 0) return;

        const fpcProducts = contents.map((product: any) => product.partNumber);
        setfpcProductIds(fpcProducts);
      })
      .catch((e) => {
        console.error("Failed to enrich cart items", e);
      });
  }, [miniCartItems, sessionAddedItems]);

  const cartSkuSet = useMemo(() => {
    const skus = (miniCartItems || [])
      .map((item: any) => item.partNumber || item.catalogEntry?.partNumber || item.catalogEntryIdentifier)
      .filter(Boolean);

    // Join → Set ensures stable reference
    return new Set(skus.join("|").split("|"));
  }, [miniCartItems?.length]);

  const resolveSkuPartNumber = (product: any) => {
    // Case 1: Already an order item / SKU
    if (product?.type === "item" && product?.partNumber) {
      return product.partNumber;
    }

    // Case 2: Catalog product with SKUs
    if (Array.isArray(product?.items) && product.items.length > 0) {
      return product.items[0].partNumber;
    }

    // Case 3: Single-SKU product fallback
    if (product?.custom?.defaultSkuId?.raw) {
      return product.custom.defaultSkuId.raw;
    }

    return null;
  };

  const resolveIndispensableSku = useCallback((item: any) => {
    // SKU
    if (item.type === "item") {
      return item.partNumber;
    }

    // Product → SKU
    if (item.items?.length > 0) {
      return item.items.find((i: any) => i.buyable === "true")?.partNumber || item.items[0]?.partNumber;
    }

    return item.partNumber;
  }, []);

  const filterIndispensables = useCallback(() => {
    if (cartUpdatingRef.current) return;

    if (!indispensables?.length) {
      setIndispensableProducts((prev) => (prev.length === 0 ? prev : []));
      return;
    }

    const filtered = indispensables.filter((item: any) => {
      const sku = resolveIndispensableSku(item);
      return sku && !cartSkuSet.has(sku);
    });

    setIndispensableProducts((prev) => (areSameProducts(prev, filtered) ? prev : filtered));
  }, [indispensables, cartSkuSet, resolveIndispensableSku]);

  useEffect(() => {
    const timer = setTimeout(() => {
      filterIndispensables();
    }, 300);

    return () => clearTimeout(timer);
  }, [filterIndispensables]);

  const handleAddIndispensableToCart = async (product: any) => {
    if (cartUpdatingRef.current) return;

    const skuPartNumber = resolveSkuPartNumber(product);
    if (!skuPartNumber) {
      console.error("Unable to resolve SKU for add to cart", product);
      return;
    }

    cartUpdatingRef.current = true;

    await dispatch(
      orderActions.ADD_ITEM_ACTION({
        partnumber: skuPartNumber,
        quantity: qty,
        isIndispensable: true,
      })
    );

    setTimeout(() => {
      cartUpdatingRef.current = false;
    }, 700);
  };

  // useEffect(() => {
  //   if (miniCartItems && miniCartItems.length > 0) {
  //     // setLoading(true);
  //     const productIds: any = [];
  //     miniCartItems.forEach((item) => {
  //       productIds.push(item.productId);
  //     });
  //     const parameters: any = {
  //       id: productIds,
  //       contractId: contract,
  //     };
  //     productsService
  //       .findProductsUsingGET(parameters)
  //       .then((res) => {
  //         if (res.data.contents && res.data.contents.length > 0) {
  //           const parentProductIds: any = [];
  //           res.data.contents.forEach((content) => {
  //             parentProductIds.push(content.parentCatalogEntryID);
  //           });
  //           const params: any = {
  //             id: parentProductIds,
  //             contractId: contract,
  //             profileName: FIND_PRODUCT_DETAIL_BY_ID_CART,
  //             excludedAttribute:
  //               mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE &&
  //               mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE.length > 0 &&
  //               mySite?.storeCfg?.userData?.PDP_FILTER_ATTRIBUTE,
  //           };
  //           productsService
  //             .findProductsUsingGET(params)
  //             .then((productData: any) => {
  //               if (productData.data.contents && productData.data.contents.length > 0) {
  //                 const fpcProducts: any = [];
  //                 productData.data.contents.forEach((product) => {
  //                   fpcProducts.push(product.partNumber);
  //                 });
  //                 setfpcProductIds(fpcProducts);
  //               }
  //             })
  //             .catch((e) => {
  //               console.log("Could not retrieve product details page informarion", e);
  //             });
  //         }
  //       })
  //       .catch((e) => {
  //         console.log("could not retreive the parent product details", e);
  //       });
  //   }
  // }, [miniCartItems]);

  useEffect(() => {
    // Always try to fetch recommendations if there is a main product in session
    let shouldFetch = false;
    if (FpcProductIds.length > 0) {
      shouldFetch = true;
    } else if (miniCartItems && miniCartItems.length > 0) {
      // If no FPC but there is a main product, try to fetch
      shouldFetch = true;
    } else if (sessionAddedItems && sessionAddedItems.length > 0) {
      // If no miniCartItems but there is a main product in session, try to fetch
      const lastMainProduct = [...sessionAddedItems].reverse().find((item) => !item.isIndispensable && item.productId);
      if (lastMainProduct && lastMainProduct.productId) {
        shouldFetch = true;
      }
    }
    if (shouldFetch) {
      fetchRemoteFeed();
    } else {
      setIsFetched(false);
    }

    return () => {
      cancels.forEach((cancel) => cancel());
    };
  }, [FpcProductIds, miniCartItems, sessionAddedItems]);

  const fetchRemoteFeed = async () => {
    // setError(false);
    // setLoading(true);

    const ebProfileid = localStorageUtil.getCrownPeakProfileId();
    const url = new URL(
      `${site.crownpeakUrl}/widget/${widgetId}/recommendations${ebProfileid ? `/${ebProfileid}` : ""}`
    );

    url.searchParams.append("fields", "id,recommendations.id");
    if (variables) {
      const variableValue = variables.match(/FPC\d+/g);
      const VariableObjectArray = { $productId: variableValue };
      url.searchParams.append("variables", JSON.stringify(VariableObjectArray));
    }

    // https://api-console.early-birds.io/widget/5e54f8e291c86c8a8c8fea82/recommendations/{{ebProfileId}}?variables={"$productId":"FPC5768157"}
    await fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((resp) => {
        if (resp && resp.recommendations) {
          const params: any = {
            contractId: contract,
            storeId: storeId,
            widget: widgetName,
            excludedAttribute:
              mySite?.storeCfg?.userData?.PLP_FILTER_ATTRIBUTE &&
              mySite?.storeCfg?.userData?.PLP_FILTER_ATTRIBUTE.length > 0 &&
              mySite?.storeCfg?.userData?.PLP_FILTER_ATTRIBUTE,
            profileName: PRODUCT_SUMMARY_PROFILE,

            cancelToken: new CancelToken(function executor(c) {
              cancels.push(c);
            }),
            partNumber: resp.recommendations?.map((p) => p.id),
          };
          productsService
            .findProductsUsingGET(params)
            .then((productData: any) => {
              const products = productData?.data?.contents || []; // Fallback to empty array
              const productMap = new Map(products.map((product: any) => [product.partNumber, product]));

              // Sort products based on the order of recommendations
              const sortedProducts = resp.recommendations.map((rec: any) => {
                return productMap.get(rec.id);
              });

              setIsFetched(true);
              setIsCartData({
                widgetId,
                recommendationId: resp.id,
                products: sortedProducts.filter((item) => item && item.partNumber),
              });
            })

            .catch((e) => {
              // setError(true);
              console.log("Could not retrieve product details page informarion", e);
            });
        }
      })
      .catch((_err) => {
        // If remote fetch fail fallback to the local feed
        setIsFetched(true);
        console.log("error fetching remote feeds", _err);
        // setError(true);
      });
    // setLoading(false);
  };
  const enrichedIndispensableProducts = indispensableProducts.map((ind) => {
    // Try to find the same product in orderItems (which has avis/review data)
    const enriched = orderItems.find((o) => o.partNumber === ind.partNumber);
    return enriched ? { ...ind, ...enriched } : ind;
  });

  const handleAddToCart = async (product: any) => {
    if (cartHandledRef.current) return;

    cartHandledRef.current = true;
    await handleAddIndispensableToCart(product);

    setTimeout(() => {
      cartHandledRef.current = false;
    }, 500);
  };
  const totalQuantity = useMemo(() => {
    if (!sessionAddedItems?.length) return 0;

    return sessionAddedItems.reduce((sum, item) => {
      return sum + Number(item.localQuantity ?? item.quantity ?? 1);
    }, 0);
  }, [sessionAddedItems]);

  return (
    <>
      {enrichedMiniCartItems.length > 0 && isFetched && (
        <StyledModal
          open={isFetched}
          onClose={() => handleCloseModal()}
          aria-labelledby=""
          aria-describedby=""
          style={{ zIndex: "2000" }}>
          <StyledBox className="modal-container modal-add-to-cart">
            <StyledIconButton onClick={() => handleCloseModal()} className="modal-close">
              <SvgClose color="black" />
            </StyledIconButton>
            <StyledBox sx={{ overflowY: { xs: "scroll", md: "auto" }, maxHeight: { xs: "75vh", md: "auto" } }}>
              <StyledGrid container px={5} columns={9} className="" sx={{ textAlign: { xs: "center", md: "left" } }}>
                <StyledGrid item xs={9} md="auto">
                  <SvgCheckThick className="rounded-green big" />
                </StyledGrid>
                <StyledGrid item xs={9} md flexGrow="1" pl={{ xs: 0, md: 5 }} pt={{ xs: 6, md: 0 }}>
                  <StyledTypography variant="h5">
                    {`${totalQuantity} produit${qty > 1 ? "s" : ""}`}
                    <Hidden smDown>
                      <br />
                    </Hidden>
                    {`${totalQuantity > 1 ? " ont été ajoutés à votre panier" : " a été ajouté à votre panier"} `}
                  </StyledTypography>
                </StyledGrid>
                <StyledGrid item xs={9} md="auto" pt={{ xs: 4, md: 2 }} pr={4} sx={{ order: { xs: "4", md: "3" } }}>
                  <StyledButton
                    onClick={() => handleCloseModal()}
                    startIcon={<SvgChevronBack />}
                    size="medium"
                    color="secondary"
                    variant="text"
                    className=""
                    sx={{ textTransform: "none", fontWeight: 400, width: { xs: "100%", md: "auto" } }}>
                    Continuer mes achats
                  </StyledButton>
                </StyledGrid>
                <StyledGrid item xs={9} md="auto" pt={{ xs: 4, md: 0 }} sx={{ order: { xs: "3", md: "4" } }}>
                  <StyledLink to={ROUTES.CART} onClick={() => handleCloseModal()}>
                    <StyledButton
                      size="medium"
                      color="secondary"
                      className=""
                      sx={{ width: { xs: "100%", md: "auto" } }}>
                      Voir mon panier
                    </StyledButton>
                  </StyledLink>
                </StyledGrid>
              </StyledGrid>
              <StyledOrderItem>
                <StyledBox mt={10}>
                  {enrichedMiniCartItems.map((item, index) => {
                    // Use the localQuantity tracked in miniCartItems (from sessionAddedItems) for price display
                    // If indispensable, always pass localQuantity = 1 (for modal display only)
                    let localQuantity = item.localQuantity || 1;
                    // If this item is being rendered as a result of clicking add-to-cart on an indispensable,
                    // forcibly set localQuantity to 1 for the modal display, regardless of session state
                    if (
                      indispensables &&
                      indispensables.length > 0 &&
                      indispensables.some((ind) => ind.partNumber === item.partNumber)
                    ) {
                      localQuantity = 1;
                    }

                    return (
                      <StyledBox key={index} px={2.5}>
                        <StyledGrid
                          item
                          container
                          columns={{ xs: 4, md: 9 }}
                          xs={9}
                          sm={8}
                          mx={"auto"}
                          mt={{ xs: 10, sm: 5 }}
                          mb={{ xs: 5, sm: "30px" }}
                          className="order-item modal"
                          alignItems="center">
                          <StyledGrid item xs={1.5} className="order-item-left">
                            <StyledBox p={2} className="order-item-left-image no-border">
                              <ImageLayout
                                src={storeUtil.getUrlPicture(item.thumbnailRaw)}
                                alt={item.name}
                                width="100%"
                              />
                            </StyledBox>
                          </StyledGrid>
                          <StyledGrid
                            container
                            item
                            xs={7.5}
                            md={10}
                            px={{ xs: 4, sm: 5 }}
                            pt={{ xs: 4, sm: 0 }}
                            pb={{ xs: 5, sm: 0 }}
                            alignItems="center"
                            className="order-item-right">
                            <StyledGrid item xs={12} md>
                              <StyledTypography variant="subtitle2" component="p" pb={1} className="">
                                {item.name}
                              </StyledTypography>
                              <ProductAvis avis={storeUtil.getAvisProduct(item)} />
                              <StyledTypography variant="body2" component="p" pt={3}>
                                {storeUtil.getAttributesProduct(item)}
                              </StyledTypography>
                            </StyledGrid>
                            <StyledGrid item pl={{ xs: 0, sm: 3 }} pt={{ xs: 3, sm: 0 }}>
                              {/* <PriceDisplay
                                showNoPriceFoundTxt
                                hideLeadInTxt
                                hideM2TextDesc
                                orderItem={{ ...item, localQuantity }}
                              /> */}
                              <PriceDisplay product={item?.productDetails} isCartPopin={true} />
                            </StyledGrid>
                          </StyledGrid>
                        </StyledGrid>
                      </StyledBox>
                    );
                  })}
                </StyledBox>
              </StyledOrderItem>
              {/* Show Pack Indispensable Products */}
              {indispensableProducts && indispensableProducts.length > 0 && (
                <ProductIndispensable
                  product={enrichedIndispensableProducts[0] || {}}
                  productMerchandisingAssociation={enrichedIndispensableProducts}
                  productPartNumber=""
                  displayPartNumber=""
                  promotion={null}
                  displayOfferPrice={0}
                  displayListPrice={0}
                  currentSelection={{}}
                  updateProductQuantity={() => {}} // eslint-disable-line @typescript-eslint/no-empty-function
                  addToCart={handleAddToCart}
                  inventoryAvailableFlag={true}
                  buyableFlag={true}
                  translation={{}}
                  loginStatus={false}
                  isB2B={false}
                  SIGNIN=""
                  selectedIndispensables={selectedIndispensables}
                  setSelectedIndispensables={setSelectedIndispensables}
                  isCartConfirmModal={true}
                />
              )}
              {indispensableProducts?.length < 1 &&
                isCartData?.products.length > 0 &&
                FpcProductIds &&
                FpcProductIds.length > 0 && (
                  <div onClick={() => handleCloseModal()}>
                    <ProductRecommended
                      title="Les clients Lapeyre ont aussi acheté ces produits"
                      description=""
                      isInModal={true}
                      isModalLoader={false}
                      bgBeige={true}
                      origin="CartConfirmModal"
                      widgetId={WIDGET_CROWNPEAK.ADD_TO_CART}
                      variable={`{ "$productId": ${FpcProductIds.map((item) => `"${item}"`)} }`}
                      isCartData={isCartData}
                    />
                  </div>
                )}
            </StyledBox>
          </StyledBox>
        </StyledModal>
      )}
    </>
  );
};

export default CartConfirmModal;
